/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type SharePdfErrorCode = (typeof SharePdfErrorCode)[keyof typeof SharePdfErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SharePdfErrorCode = {
  analysis_not_found: "analysis_not_found",
  clients_not_found: "clients_not_found",
  client_not_found: "client_not_found",
} as const;
